import { render, staticRenderFns } from "./service-edit.vue?vue&type=template&id=1472c1c1&scoped=true&"
import script from "./service-edit.vue?vue&type=script&lang=ts&"
export * from "./service-edit.vue?vue&type=script&lang=ts&"
import style0 from "./service-edit.vue?vue&type=style&index=0&id=1472c1c1&prod&lang=scss&scoped=true&"
import style1 from "./service-edit.vue?vue&type=style&index=1&id=1472c1c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472c1c1",
  null
  
)

export default component.exports